/**
 * 获取地址中的 search 参数
 * @param {RouteComponentProps} [props]
 * @returns {Record<string, string | Array<string>>}
 */
export const getSearchParams = (props) => {
  let search;
  if (typeof props?.location === 'undefined') {
    search = window.location.href.match(/^[^?]*\??([^#]*)?/)?.[1] || '';
  } else {
    search = props.location.search.replace(/^\?/, '');
  }
  const result = {};
  search.split('&').forEach(param => {
    const [key, _value] = param.split('=');
    const value = _value ? decodeURIComponent(_value) : undefined;
    if (key in result) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else if (key !== '') {
      result[key] = value;
    }
  });
  return result;
}
